import Vue from 'vue';
import VueMatchMedia from 'vue-match-media';

Vue.use(VueMatchMedia);
